export default {
    login: {
        method: 'POST',
        url: '/sortingCityAdmin/user/login',
        name: '登录接口'
    },
    // 免密登录
    govFreeLogin: {
        method: 'POST',
        url: '/sortingCityAdmin/user/gov-free-login',
        name: '免密登录'
    }
    
}
